import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";

import { NoDataUI } from "../common/noDataUI/noDataUI.common";
import ArticleCard from "../common/articleCard/ArticleCard.common";
import Title from "../common/title/Title.common";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";
import ActivityIndicator from "../hoc/activityIndicator/ActivityIndicator.hoc";

// ACTIONs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getNewsletterAction } from "../../actions/Actions";

const NewsLetterPage = (props) => {
  const { setHeaderTitle, language, researchProgram } = useAuth();
  const { getNewsletterAction, newsletter } = props;
  const { listLoader, list } = newsletter;

  useEffect(() => {
    setHeaderTitle(language.key.newsletter);
  }, [setHeaderTitle, language.key.newsletter]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getNewsletterAction(researchProgram?.id);
  }, [getNewsletterAction, researchProgram]);

  return (
    <CompWrapper>
      <Title title={language.key.newsletter} hide_SeeAll />
      <ActivityIndicator animating={listLoader}>
        {list.length > 0 ? (
          <div className="news-container">
            {list.map((val, index) => {
              return (
                <div key={index}>
                  <ArticleCard data={val} />
                </div>
              );
            })}
          </div>
        ) : <NoDataUI />}
      </ActivityIndicator>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    newsletter: state.newsletter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getNewsletterAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsLetterPage);
